var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileCircle = function SvgProfileCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M10 19.997c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M10 11.938a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6M10 19.996a9.94 9.94 0 0 0 6.5-2.41 6.88 6.88 0 0 0-13 0 9.94 9.94 0 0 0 6.5 2.41"
  })));
};
export default SvgProfileCircle;